let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dpTsM")).then(() => parcelRequire('hpPu5'));